import { useMemo } from "react";
import PropTypes from "prop-types";

import useLanguageChange from "../../hooks/useLanguageChange";

import CenterModal from "../UI/Modal/CenterModal";

// Cancel upload modal
const DeleteConfirmationModal = ({ onCloseDeleteImageModal, onConfirmDeleteImage }) => {
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    const onCloseHandler = () => {
        onCloseDeleteImageModal();
    };

    const onConfirmHandler = () => {
        onConfirmDeleteImage();
    };

    const header = useMemo(() => {
        return (
            <>
                <h5 className='modal-title'>{localisedValues?.delete_image_title}</h5>
                <button type='button' className='btn-close' onClick={() => onCloseHandler()} aria-label='Close'>
                    <span className='btn-icon icon-close-light'></span>
                </button>
            </>
        );
    }, [localisedValues]);

    const body = useMemo(() => {
        return (
            <div className='privacy-policy-modal-text'>
                <p>{localisedValues?.are_you_sure_you_want_to_delete_image}</p>
            </div>
        );
    }, [localisedValues]);

    const footer = useMemo(() => {
        return (
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' onClick={() => onCloseHandler()}>
                        {localisedValues?.cancel}
                    </button>
                </div>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={() => onConfirmHandler()}>
                        {localisedValues?.delete_lable}
                    </button>
                </div>
            </div>
        );
    }, [localisedValues]);

    return (
        <CenterModal
            showModal={true}
            closeModal={onCloseHandler}
            modalClass='default-modal modal-small mob-bottom-top'
            className='modal-dialog-centered'
            bodyClassName='default-custom-scroll'
            header={header}
            body={body}
            footer={footer}
            keyboard={true}
            backdrop={"static"}
        />
    );
};

DeleteConfirmationModal.propTypes = {
    onCloseDeleteImageModal: PropTypes.func,
    onConfirmDeleteImage: PropTypes.func,
};

export default DeleteConfirmationModal;
